import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../utils/i18n';

const NotFoundPage = () => {
  const t = useT();
  return (
    <div className="text-center mt-5">
      <h2>{t('404 - Page Not Found')}</h2>
      <p>{t('Sorry, the page you are looking for does not exist.')}</p>
      <Link to="/" className="btn btn-primary">{t('Go to Home')}</Link>
    </div>
  );
};

export default NotFoundPage;